import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

interface Article {
  id: number;
  title: string;
  content: string;
  image: string | null;
  created_at: string;
  category: string;
}

const Articles: React.FC = () => {
  const [articles, setArticles] = useState<Article[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch('https://fellfell.ir/api/test-full.php?action=api-articles')
      .then(res => res.json())
      .then(data => {
        if (data.success && Array.isArray(data.data)) {
          setArticles(data.data);
        } else {
          setError('خطا در دریافت مقالات');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('خطا در ارتباط با سرور');
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="loading">در حال بارگذاری...</div>;
  if (error) return <div className="alert alert-error">{error}</div>;

  return (
    <>
      <div className="page-header">
        <div className="container">
          <h1>مقالات آموزشی</h1>
        </div>
      </div>
      <section style={{ padding: '20px 0' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '25px' }}>
            {articles.length > 0 ? (
              articles.map(a => (
                <div key={a.id} style={{ background: '#fff', borderRadius: '16px', padding: '20px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
                  <img 
                    src={`https://fellfell.ir/uploads/articles/${a.image || 'default.jpg'}`} 
                    alt={a.title} 
                    style={{ width: '100%', height: '180px',     aspectRatio: '1/1',        // ← کلید اصلی
objectFit: 'cover', borderRadius: '12px', marginBottom: '15px' }}
                    onError={(e) => { e.currentTarget.src = 'https://fellfell.ir/assets/images/article-placeholder.jpg'; }}
					  loading="lazy"               // ← اضافه شد برای بهینه‌سازی
  decoding="async"             // ← اضافه شد برای بهینه‌سازی

					
                  />
                  <h3><Link to={`/article/${a.id}`} style={{ color: '#1e3a1e' }}>{a.title}</Link></h3>
                  <p style={{ color: '#666', marginBottom: '10px' }}>{a.content?.substring(0, 120) || ''}...</p>
                  <Link to={`/article/${a.id}`} className="btn btn-primary btn-sm">ادامه مطلب</Link>
                </div>
              ))
            ) : (
              <p>مقاله‌ای یافت نشد.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default Articles;